import { MockNote } from '@/components/foundations';
import { AppShell, PageHeader, PageTitle } from '@/components/layout';
import { StatCard } from '@/components/data';
import { InstallmentTimeline, remaining } from './components';
import { COMMITTED_BY_MONTH, INSTALLMENTS, brl } from '@/mocks/financas';

/** Timeline de parcelamentos (próximos 12 meses) — mock. */
export function FinParcelasPage() {
  const rest = INSTALLMENTS.reduce((s, p) => s + remaining(p), 0);
  return (
    <AppShell>
      <main className="content">
        <PageHeader subtitle="Quanto ainda vem de parcela em cada mês." period="Próximos 12 meses" />
        <PageTitle title="Parcelamentos" />
        <section className="fin-grid-3">
          <StatCard icon="layers" label="Ainda a pagar" value={brl(rest)} hint={`${INSTALLMENTS.length} compras ativas`} />
          <StatCard icon="cal" label="Próximo mês" value={brl(1034.7)} hint="novembro" />
          <StatCard icon="checkc" label="Última parcela" value="jun/2027" hint="LOJA ELETRO EXEMPLO" />
        </section>
        <InstallmentTimeline months={COMMITTED_BY_MONTH} purchases={INSTALLMENTS} />
        <MockNote />
      </main>
    </AppShell>
  );
}
